/**
 * @generated SignedSource<<164ecf53214aadf298e37fd27cd8d48f>>
 * @relayHash 71f49fde0cd75ae2309721d154d50934
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID abae208b9ac313389d894b9c7b3fea8288d47ec75e5ca5dde9496c11aab0560b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useClassificationChangeStateQuery$variables = {
  spaceKey: string;
};
export type useClassificationChangeStateQuery$data = {
  readonly classificationLevels: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly description: string | null | undefined;
    readonly guideline: string | null | undefined;
    readonly guidelineADF: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly order: number | null | undefined;
    readonly status: string;
  }> | null | undefined;
  readonly space: {
    readonly defaultClassificationLevelId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly metadata: {
      readonly totalCurrentPages: AGG$Long;
    };
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type useClassificationChangeStateQuery = {
  response: useClassificationChangeStateQuery$data;
  variables: useClassificationChangeStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "defaultClassificationLevelId"
      },
      {
        "concreteType": "SpaceMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCurrentPages"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "ContentDataClassificationLevel",
    "kind": "LinkedField",
    "name": "classificationLevels",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "order"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "kind": "ScalarField",
        "name": "guideline"
      },
      {
        "kind": "ScalarField",
        "name": "guidelineADF"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useClassificationChangeStateQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useClassificationChangeStateQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "71f49fde0cd75ae2309721d154d50934",
    "id": "abae208b9ac313389d894b9c7b3fea8288d47ec75e5ca5dde9496c11aab0560b",
    "metadata": {},
    "name": "useClassificationChangeStateQuery",
    "operationKind": "query",
    "text": "query useClassificationChangeStateQuery($spaceKey:String!){space(key:$spaceKey){id,name,defaultClassificationLevelId,metadata{totalCurrentPages}},classificationLevels{id,name,description,color,order,status,guideline,guidelineADF}}"
  }
};
})();

(node as any).hash = "40c43bb21342ea1c70330b876183ae1d";

export default node;
